var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"video-preview"}},[_c('loading-icon'),_c('p',{staticClass:"loading-message"},[_vm._v("\n\t\tWe are creating your custom video. This may take a few minutes.\n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }